module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datatable"
  }, [_c('div', {
    staticClass: "filterer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterstring),
      expression: "filterstring"
    }],
    attrs: {
      "type": "text",
      "placeholder": "filter"
    },
    domProps: {
      "value": (_vm.filterstring)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterstring = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('ul', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a667508","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Datatable.vue
// module id = 614
// module chunks = 1